import { z } from 'zod';

export const downloadUrlResponseSchema = z.object({
  location: z.string().url(),
  lastModified: z.string().datetime(),
});

export type DownloadUrlResponse = z.infer<typeof downloadUrlResponseSchema>;
